import Image from 'next/image'
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'

interface SecBenefitsProps {
	text?: {
		text?: string
	}
	image?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_disk: string
			}
		}
	}
}

export const fields = [
	// text
	'text.text',

	// image
	'image.alt',
	'image.image_file.image.id',
	'image.image_file.image.filename_download',
] as const

export default function SecBenefits({ data }: { data: SecBenefitsProps }) {
	return (
		<section className='SecBenefits relative bg-[#e0e0e0] md:mb-16'>
			<div className='container'>
				<div className='flex flex-wrap'>
					{/* Image Section - Full width to screen edge */}
					<div className='w-full lg:w-1/2'>
						<div className='relative lg:absolute w-full aspect-square lg:top-0 lg:left-0 lg:w-[calc(50%-3rem)] lg:h-[calc(100%+4rem)] max-sm:h-[350px] max-sm:w-screen max-sm:-ml-6'>
							{data?.image?.image_file?.image?.id && (
								<Image
									src={getReadableImageUrl(
										data.image.image_file.image.id,
										data.image.image_file.image.filename_disk || ''
									)}
									alt={data.image?.alt || ''}
									fill
									className='object-cover md:rounded-br-[66px]'
									priority
								/>
							)}
						</div>
					</div>

					{/* Content Section */}
					<div className='w-full lg:w-1/2 py-8 md:py-16'>
						{/* Benefits Section */}
							{data?.text?.text && (
								<div
									className='grid gap-6 mb-12'
									dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
								/>
							)}
					</div>
				</div>
			</div>
		</section>
	)
}